import { useEffect, useState } from 'react';
const createTokenKey = (key) => `token:${key}`;
const createAdMetricsKey = (key) => `adMetrics:${key}`;
const createOrgKey = (key) => `org:${key}`;
export const clearLocalToken = (key) => sessionStorage.removeItem(createTokenKey(key));
export const getLocalToken = (key) => sessionStorage.getItem(createTokenKey(key));
export const setLocalToken = (key, token) => sessionStorage.setItem(createTokenKey(key), token);
export const getLocalOrg = (key) => sessionStorage.getItem(createOrgKey(key));
export const setLocalOrg = (key, token) => sessionStorage.setItem(createOrgKey(key), token);
export const clearLocalOrg = (key) => sessionStorage.removeItem(createOrgKey(key));
export const getAdMetrics = (key) => sessionStorage.getItem(createAdMetricsKey(key));
export const setAdMetrics = (key, data) => sessionStorage.setItem(createAdMetricsKey(key), JSON.stringify(data));
export const useSessionStorage = (key, json) => {
    const existing = sessionStorage.getItem(key);
    const [storageValue, setStorageValue] = useState(json && existing ? JSON.parse(existing) : existing);
    useEffect(() => {
        if (key) {
            const existing = sessionStorage.getItem(key);
            existing && setStorageValue(json ? JSON.parse(existing) : existing);
        }
    }, [key]);
    const setSessionStorage = (value) => {
        sessionStorage.setItem(key, JSON.stringify(value));
        setStorageValue(value);
    };
    return [storageValue, setSessionStorage];
};
//# sourceMappingURL=sessionStorage.js.map